<template>
  <v-container fluid class="titleContent">
    <v-row justify="center" align="center" class="text-center">
      <v-col>
        <v-img
          alt="Vuetify Logo"
          class="shrink mx-auto my-4"
          contain
          :src="cTitleImg"
          transition="scale-transition"
          width="180"
        />
        <h3 v-show="h" class="sr-only">{{ title }}</h3>
        <div class="ct-text-subtitle bold">{{ title }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "最新消息"
    },
    titleImg: {
      type: String,
      default: "common/icon_promotion.svg"
    },
    h: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cTitleImg() {
      let path = this.titleImg;
      return require(`@/assets/images/${path}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.titleContent {
  background-repeat: repeat;
  background-position: 50% 50%;
  background-image: url("~@/assets/images/announce/bg_title.png");
}
</style>
